module.exports = __webpack_public_path__ + "img/Syngenta-logo.6d47d498.png";